import React, { useEffect, useState } from "react";
import { Form, FormControl, InputGroup } from "react-bootstrap";
import { useCustomer } from "../actionables/store";
import moment from "moment";
import { useToast } from "modules/navbar/top/store/toasterStore";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { specialSubCategories } from 'modules/utilities/utility';
import { createMeidcalEscalationTicket } from 'modules/navbar/top/store';
import secureLocalStorage from "react-secure-storage";

function InputFeedBack({
  setFormData,
  formData,
  orders,
  orderDisplayId,
  setOrderDisplayId,
  setTicketObject
}) {

  const { customerData } = useCustomer();
  const [subCat, setSubCat] = useState("");

  const orderId = orders?.filter((item) => {
    return item?.order_display_id == orderDisplayId;
  });

  const { fetchNearestSlot } = createMeidcalEscalationTicket();

  const handleReactions = (event) => {
    const reactions = event.target.value;
    setFormData((prevFormData) => ({
      ...prevFormData,
      reactions,
    }));
  };
  let ticketTemplate = {
    action_taker: "",
    address: {},
    author_id: "",
    case_id: "",
    category: "",
    comment: {
      commented_by: "",
      description: "",
      type: "",
    },
    current_assignment: "",
    due_date: "",
    is_internal: false,
    priority: "",
    products: [],
    provider: null,
    provider_meta: {
      descriptionValue: "",
      due_date: "",
      subject: "",
    },
    remark: "",
    source: "crm",
    source_meta: {
      order_details: "",
      order_display_id: "",
      order_id: "",
      title: "",
    },
    sub_category: "",
    waba: false,
  };

  const setTicketData = () => {
    ticketTemplate = {
      ...ticketTemplate,
      action_taker: secureLocalStorage.getItem("id"),
      address: {
        city: orderId?.[0]?.order_meta?.customer?.default_address?.city ?? "-",
        locality: orderId?.[0]?.order_meta?.shipping_address?.address1 ?? "-",
        landmark: orderId?.[0]?.order_meta?.shipping_address?.address2 ?? "-",
        state: orderId?.[0]?.order_meta?.shipping_address?.province ?? "-",
        pincode: orderId?.[0]?.order_meta?.shipping_address?.zip ?? "-",
      },
      author_id: secureLocalStorage.getItem("id"),
      priority: "4",
      case_id: customerData?.id,
      category: "medical_escalations",
      comment: {
        commented_by: secureLocalStorage.getItem("id"),
        description: formData.reactions,
        type: "medical_escalations",
      },
      current_assignment: "00f941d7-8c24-4e8d-a60c-8f0432378ec6", //priyanakKanojia,
      due_date: new Date(
        new Date(moment().format("YYYY-MM-DDTHH:mm")).getTime() + 86400000
      ).toISOString(),
      provider_meta: {
        descriptionValue: formData.reactions,
        due_date: new Date(
          new Date(moment().format("YYYY-MM-DDTHH:mm")).getTime() + 86400000
        ).toISOString(),
        subject: `${orderDisplayId} : ${orderId?.[0]?.order_meta?.customer?.first_name
          } : ${"medical_escalations"} -> ${subCat}`,
      },
      source_meta: {
        title: "create_ticket",
        order_details: selectedText,
        order_display_id: orderDisplayId,
        order_id: orderId?.[0]?.id,
      },
      sub_category: subCat,
      waba: false,
    };
  };

  const handleCategory = (event) => {
    const category = event.target.value;
    if(specialSubCategories.includes(category)){
      fetchNearestSlot()
    }
    setFormData((prevFormData) => ({
      ...prevFormData,
      category,
    }));
    setSubCat(category);
  };

  useEffect(() => {
    if (subCat !== "" && orderDisplayId) {
      setTicketData();
      setTicketObject(ticketTemplate);
    }
  }, [subCat, orderDisplayId]);

  let selectedText = `Customer Name: ${orderId?.[0]?.order_meta?.customer?.first_name} Order ID: ${orderDisplayId}`;
  return (
    <>
      <div className="my-3 border-bottom border-1 p-2">
        <InputGroup className="d-flex">
          <InputGroup.Text className="flex-1">
            <h4 className="p-0 m-0">Product Reaction (comments)</h4>
          </InputGroup.Text>
          <FormControl
            className="flex-1"
            as="textarea"
            aria-label="Product Reaction"
            onChange={handleReactions}
          />
        </InputGroup>
      </div>
      <div className="my-3">
        <div className="d-flex align-itms-center justify-content-between border-bottom border-1 p-2">
          <h4 className="flex-1 align-self-center p-0 m-0">Sub Category</h4>
          <div className={` flex-1`}>
            <Form.Select
              aria-label="Default select example"
              onChange={handleCategory}
              defaultValue=""
              name="subcat"
              className="outline-none border-none"
            >
              <option value="" disabled selected hidden>
                Subcategory
              </option>{" "}
              <option value="hairfall_issue">Hairfall</option>
              <option value="constipation_issue">Constipation</option>
              <option value="dandruff_issue">Dandruff</option>
              <option value="health_issue">Health condition</option>
              <option value="boils_issue">Boils</option>
              <option value="itching_issue">Itching</option>
              <option value="product_reaction_issue">Product Reactions</option>
              <option value="sexual_issue">Sexual Issue</option>
              <option value="gastric_issue">Gastric Issue</option>
              <option value="five_months_no_results">Five Months No Results</option>
              <option value="deterioration">Deterioration</option>
              <option value="other_issue">other</option>
            </Form.Select>
          </div>
        </div>
      </div>
    </>
  );
}

export default InputFeedBack;